import React = require("react");
import StoreContainer from "../stores/StoreContainer";
import { EngagementConfiguration } from "../types";

export default function useDocumentTitle(config: EngagementConfiguration) {
  const isPopOut = StoreContainer.FrameStore.isPopOut();

  React.useEffect(() => {
    if (!isPopOut || !config) {
      return;
    }

    if (config.PopoutDocumentTitle) {
      window.parent.document.title = config.PopoutDocumentTitle;
    }
  }, [isPopOut, config]);
}
